import { Box, Button, Container, Stack, Typography } from '@mui/material';
import ChatRoundedIcon from '@mui/icons-material/ChatRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import { useT } from '../../i18n';
import { CONTACT_EMAIL, WHATSAPP_NUMBER } from './config';

export function ContactCta() {
  const t = useT();

  return (
    <Box
      component="section"
      id="kontak"
      sx={{ bgcolor: 'primary.main', color: 'primary.contrastText', py: { xs: 6, md: 9 } }}
    >
      <Container maxWidth="md" sx={{ textAlign: 'center' }}>
        <Typography variant="h3" fontWeight={700} sx={{ letterSpacing: '-0.3px' }}>
          {t('landing.contact.title')}
        </Typography>
        <Typography variant="body1" sx={{ mt: 1.5, opacity: 0.85 }}>
          {t('landing.contact.sub')}
        </Typography>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={2}
          justifyContent="center"
          sx={{ mt: 4 }}
        >
          <Button
            size="large"
            variant="contained"
            startIcon={<ChatRoundedIcon />}
            sx={{
              bgcolor: 'background.paper',
              color: 'text.primary',
              '&:hover': { bgcolor: 'background.default' },
            }}
            component="a"
            href={`https://wa.me/${WHATSAPP_NUMBER}`}
            target="_blank"
            rel="noopener"
          >
            {t('landing.contact.whatsapp')}
          </Button>
          <Button
            size="large"
            variant="outlined"
            color="inherit"
            startIcon={<EmailRoundedIcon />}
            component="a"
            href={`mailto:${CONTACT_EMAIL}`}
          >
            {t('landing.contact.email')}
          </Button>
        </Stack>
      </Container>
    </Box>
  );
}
